import type { SharedUsersStore, UsersListStore, UsersPhonesStore } from '@/stores';

interface Params {
    needsPhone: boolean;
    needsPassword: boolean;
    sharedUsersStore: SharedUsersStore;
    usersPhonesStore: UsersPhonesStore;
    usersListStore: UsersListStore;
}

const hasAnyRecipientMissingDetails = ({
    needsPhone,
    needsPassword,
    sharedUsersStore,
    usersPhonesStore,
    usersListStore,
}: Params): boolean => {
    if (!needsPhone && !needsPassword) return false;

    const { userGroupsList } = usersListStore;

    const isEmailMissing = (email: string): boolean => {
        if (needsPhone) {
            const { phonesVector } = usersPhonesStore.getUserPhone(email);
            if (!phonesVector?.currentPhone?.phone) return true;
        }
        if (needsPassword) {
            const info = sharedUsersStore.getRecipientPasswordInfo(email);
            if (!info?.maskedPassword) return true;
        }
        return false;
    };

    return sharedUsersStore.recipientsList.some((r) => {
        if (r.type === 'user') return isEmailMissing(r.email);
        const group = userGroupsList.find((g) => g.groupId === r.id);
        if (!group) return false;
        return (group.members || []).some((m) => isEmailMissing(m.email));
    });
};

export default hasAnyRecipientMissingDetails;
